"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPhone = void 0;
const isPhone = () => {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
    ];
    return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
};
exports.isPhone = isPhone;
